import { takeLatest, call, put } from "redux-saga/effects";

import API_ENDPOINTS from "@services/apiConfig";
import axios from 'axios';

export const actionTypes = {
    fetchBusinessCategories: 'PARTNER/FETCH_BUSINESS_CATEGORIES_INITIATED',
    fetchBusinessCategoriesSuccess: 'PARTNER/FETCH_BUSINESS_CATEGORIES_SUCCESS',
    fetchBusinessCategoriesFailed: 'PARTNER/FETCH_BUSINESS_CATEGORIES_FAILED',
};

export const actions = {
    fetchBusinessCategories: () => ({ type: actionTypes.fetchBusinessCategories }),
};

const initialState = {
    fetching: false,
    fetched: false,
    data: [],
    errMsg: null,
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.fetchBusinessCategories: {
            return {
                ...state,
                fetching: true,
            };
        }
        case actionTypes.fetchBusinessCategoriesSuccess: {
            return {
                ...state,
                fetched: true,
                fetching: false,
                data: action.payload,
            };
        }
        case actionTypes.fetchBusinessCategoriesFailed: {
            return {
                ...state,
                fetched: true,
                errMsg: action.payload,
            };
        }
        default:
            return state;
    }
};

export const selectors = {
    isFetching: (state) =>  state.partnerApp.businessCategories.fetching,
    isFetched: (state) => state.partnerApp.businessCategories.fetched,
    getCategories: (state) => {
        return state.partnerApp.businessCategories.data || [];
    }
};

function* fetchWorker() {
  try {
    const response = yield call(
      [axios, 'get'],
      API_ENDPOINTS.REFER.BUSINESS_CATEGORIES
    )
    yield put({ type: actionTypes.fetchBusinessCategoriesSuccess, payload: response.data.business_categories
         });
  } catch (err) {
    const errResponse = yield err.response;
  }
}

export function* saga() {
    yield takeLatest(actionTypes.fetchBusinessCategories, fetchWorker);
}